import { simpleSection } from '../helper'

export default [
  {
    generate({ patientData, parameters }) {
      const hypothesis = parameters['asthma:hypothesis']?.label.text

      const textPieces = [
        `Paciente ${patientData.name}, ${patientData.age} anos, apresenta ${
          hypothesis?.toLocaleLowerCase() ?? '[Não disponível]'
        }`,
      ]

      if (!hypothesis || hypothesis === 'Sem diagnóstico de asma') {
        return [simpleSection(textPieces)]
      }

      const cidMap = {
        Asma: 'J45',
        'Asma grave': 'J45',
        'Asma grave eosinofílica': 'J45.1',
        'Asma grave não eosinofílica': 'J45.0',
        'Asma grave alérgica': 'J45.0',
        'Asma grave não alérgica': 'J45.1',
        'Asma grave eosinofílica alérgica': 'J45.8',
        'Asma grave eosinofílica não alérgica': 'J45.1',
        'Asma grave não eosinofílica alérgica': 'J45.0',
        'Asma grave T2 baixo (não eosinofílica e não alérgica)': 'J45.1',
      }

      textPieces.push(`(CID: ${cidMap[hypothesis] ?? '[Inválido]'})`)
      return [simpleSection(textPieces)]
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [],
    },
  },
]
